export const FontFamily = {
  primary: "Montserrat-Medium",
  secondary: "Comfortaa",
  semiBold: "Montserrat-SemiBold",
  bold: "Montserrat-Bold",
  medium: "Montserrat-Medium",
  boldItalic: "Montserrat-BoldItalic",
} as const;

export const FontSize = {
  heading: "3.3em",
  title: "34px",
  subheading: "27px",
  medium: "24px",
  small: "16px",
  base: "14px",
  large: "20px",
} as const;

export const FontVariant = {
  heading: "heading",
  title: "title",
  subheading: "subheading",
  medium: "medium",
  small: "small",
  base: "base",
  large: "large",
} as const;
export const FontWeight = {
  normal: 400,
  semiBold: 600,
  bold: 700,
} as const;

export const FontStyle = {
  italic: "italic",
} as const;
